export default __webpack_public_path__ + "static/sansation.regular-9be04a011dc2beea99854a1dd93267bf.ttf";